import React, { useRef, useState } from "react"
import { IUser } from "../../../types/user/IUser"
import { ModalConfirm } from "../../common/element/ModalConfirm"
import { IModalMessage } from "../../../types/error/IModalMessage"
import { ModalPopUp } from "../../common/element/ModalPopUp"
import { useNavigate } from "react-router-dom"
import { DASHBOARD_ROUTE, getAdminUserViewRoute } from "@/routes"
import * as TrinityAPI from "@/requests/TrinityAPI"
import { FloatingRates } from "@/components/admin/company/floatingRate/FloatingRates"
import { useStore } from "@/stores/RootStoreContext"
import { ClientCurrencyRate } from "@/components/common/page/rate/ClientCurrencyRate"

export const UserListItem: React.FC<{
  user: IUser
  isUsersRole: boolean
  extendedUserId: number | null
  setExtendedUserId: (value: number | null) => void
  remove: (id: number) => void
  ban: (id: number) => void
}> = ({ user, remove, ban, isUsersRole, extendedUserId, setExtendedUserId }) => {
  const { userStore } = useStore()
  const navigate = useNavigate()
  const userMenu = useRef<HTMLDivElement>(null)

  const [modalConfirm, setModalConfirm] = useState<IModalMessage>()
  const [modalMessage, setModalMessage] = useState<IModalMessage | null>(null)

  const isShowMore = extendedUserId === user.userId

  const toggleMenu = (e?: React.MouseEvent<HTMLButtonElement>) => {
    e?.stopPropagation()

    if (userMenu.current) {
      if (userMenu.current.style.left === "0%") {
        userMenu.current.style.display = "none"
        userMenu.current.style.left = "100%"
      } else {
        userMenu.current.style.display = "flex"
        userMenu.current.style.left = "0%"
      }
      //userMenu.current.style.left = userMenu.current.style.left === "0%" ? "100%" : "0%";
    }
  }

  const confirmRemove = (val: any) => {
    if (val) {
      toggleMenu()
      remove(val)
    }
  }
  const confirmBan = (val: any) => {
    if (val) {
      toggleMenu()
      ban(val)
    }
  }

  const handleSwitch = () => {
    TrinityAPI.switchToUser(Number(user.userId), response => {
      if (response.status === 200) {
        const { data } = response

        if (data.token) {
          userStore.setToken(response.data.token)
          navigate(DASHBOARD_ROUTE)
        }
      }
    })
  }

  const handleItemClick = () => {
    if (!isUsersRole) {
      return
    }

    if (isShowMore) {
      setExtendedUserId(null)
    } else {
      setExtendedUserId(user.userId || null)
    }
  }

  return (
    <div>
      <ModalConfirm message={modalConfirm} setMessage={setModalConfirm} />
      <ModalPopUp message={modalMessage} close={() => setModalMessage(null)} />
      <li className="global-item" onClick={handleItemClick}>
        <div className="global-scroll-block">
          <p className={`global-item-text global-name${user.isBanned ? "-lock" : ""} cols-4`}>{user.name}</p>
          <p className="global-item-text global-bank cols-4">{user.username}</p>
          <p className="global-item-text globak-swift cols-4">{user.telegram ? `@${user.telegram}` : `-`}</p>
          <p className="global-item-text globak-num cols-4">{user.phone || "-"}</p>
        </div>
        {userStore.isAdmin && (
          <>
            <button id="openmenu_INN" onClick={toggleMenu} />
            <div id="menu-itemINN" ref={userMenu}>
              <p className="menu-cpmpany-button cols-4" onClick={() => navigate(getAdminUserViewRoute(user.userId))}>
                Редактировать
              </p>
              <p
                className="menu-cpmpany-button cols-4"
                onClick={() =>
                  setModalConfirm({
                    title: user.isBanned ? "Разблокировать пользователя?" : "Заблокировать пользователя?",
                    text: `Вы действительно желаете ${
                      user.isBanned ? "разблокировать" : "заблокировать"
                    } пользователя ${user?.name}?`,
                    callbackValue: user.userId,
                    _callback: confirmBan
                  })
                }
              >
                {user.isBanned ? "Разблокировать" : "Заблокировать"}
              </p>
              <p
                className="menu-cpmpany-button cols-4"
                onClick={() =>
                  setModalConfirm({
                    title: "Удалить пользователя?",
                    text: `Вы действительно желаете удалить пользователя ${user?.name}?`,
                    callbackValue: user.userId,
                    _callback: confirmRemove
                  })
                }
              >
                Удалить
              </p>
              <p className="menu-cpmpany-button cols-4" onClick={handleSwitch}>
                Войти
              </p>
              <button id="closemenuINN" onClick={toggleMenu} />
            </div>
          </>
        )}
      </li>
      {isShowMore && isUsersRole && user.userId && (
        <div>
          <div className="grid-3-columns padding-24">
            <FloatingRates userId={user.userId} rateType={"AMOUNT"} />
            <FloatingRates userId={user.userId} rateType={"M_VAL"} />
            <ClientCurrencyRate userId={user.userId} />
          </div>
        </div>
      )}
    </div>
  )
}
